import { collections } from "@/mocks/homeContent";
import { SectionHead } from "./Common";

export default function Collections() {
  return (
    <section id="collections" className="bg-background-50 py-14 md:py-20 scroll-mt-16 md:scroll-mt-20">
      <div className="container-page">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <SectionHead
            eyebrow="Collection · 专题合集"
            title="追更不完的热门专题"
            desc="编辑部持续维护的长期栏目，每一期都把相关话题沉淀成可回溯的完整合集，随时可以回头细读。"
          />
          <p className="max-w-sm text-sm leading-relaxed text-foreground-500">
            <i className="ri-folder-open-line mr-1 text-primary-500"></i>
            合集持续更新，本页展示部分代表专题。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {collections.map((c, idx) => (
            <article
              key={c.id}
              className="group relative flex min-h-[260px] overflow-hidden rounded-lg md:min-h-[300px]"
            >
              <img
                src={c.image}
                alt={c.title + "专题合集封面"}
                className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/35 to-black/10"></div>
              <div className="relative z-10 mt-auto flex flex-col p-5 md:p-6">
                <span className="mb-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
                  <i className="ri-folder-fill"></i>
                  {String(c.count).padStart(2, "0")} 期专题
                </span>
                <h3 className="font-heading text-xl font-bold text-background-50 md:text-2xl">{c.title}</h3>
                <p className="mt-1 text-sm font-medium text-accent-300">{c.subtitle}</p>
                <p className="mt-2 max-w-xl text-sm leading-relaxed text-background-100/85">{c.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-background-100/70">
                  <i className={"ri-arrow-right-line transition-transform group-hover:translate-x-1 " + (idx % 2 === 0 ? "rotate-0" : "")}></i>
                  追更该专题合集
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}